<template>
  <w-icon-wrapper
    width="20"
    height="24"
    viewBox="0 0 20 24"
    icon-name='work-word-icon'
  >
    <g
      id="Word"
      transform="translate(-3243 -16012.433)"
    >
      <path
        id="Pfad_55706"
        data-name="Pfad 55706"
        d="M14,31.262l3.172,3.171H14ZM2,30.433H12v6h6v14H2Zm-2-2v24H20v-18l-6-6Z"
        transform="translate(3243 15984)"
        fill="currentColor"
      />
      <path
        id="Pfad_55707"
        data-name="Pfad 55707"
        d="M12.519,45.213l1.148-6.07h1.752l-1.892,8.531h-1.77l-1.388-5.707L8.98,47.674H7.21L5.318,39.143H7.07L8.224,45.2,9.63,39.143h1.489Z"
        transform="translate(3243 15984)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconWord' };
</script>
